import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-300 border-t border-slate-900" data-id="element-236">
      {/* Anfahrt / Map Section */}
      <div className="bg-slate-900 py-16 border-b border-slate-800" data-id="element-237">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-239">
            <div data-id="element-240">
              <h3 className="text-2xl font-extrabold text-white mb-6 tracking-tight flex items-center gap-3" data-id="element-241">
                <MapPinIcon className="w-6 h-6 text-[#59d0d4]" data-id="element-242" />
                Anfahrt & Adresse
              </h3>
              <div className="bg-slate-800/50 p-8 rounded-2xl border border-slate-700" data-id="element-243">
                <p className="text-lg font-bold text-white mb-2" data-id="element-244">
                  2N Kurse GbR
                </p>
                <p className="text-[#748282] mb-1" data-id="element-245">
                  Dres. Schwenk, Striegel, Herzog
                </p>
                <p className="text-[#748282] mb-1" data-id="element-246">Ludwigsplatz 1a</p>
                <p className="text-[#748282] mb-6" data-id="element-247">90403 Nürnberg</p>

                <a href="https://maps.app.goo.gl/dBPXpibLgyhH5JyE8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 text-sm font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all shadow-lg" data-id="element-248">
                  Route auf Google Maps planen
                </a>
              </div>
            </div>

            <div className="h-80 rounded-2xl overflow-hidden shadow-2xl border border-slate-700" data-id="element-249">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2594.881452140409!2d11.07221877689121!3d49.45212507142273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479f57a6279930f7%3A0xcb1e220677a288c5!2sLudwigsplatz%201a%2C%2090403%20N%C3%BCrnberg!5e0!3m2!1sde!2sde!4v1709000000000!5m2!1sde!2sde" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Standort" data-id="element-250"></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="py-16" data-id="element-251">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-253">
            <div className="col-span-1 md:col-span-2" data-id="element-254">
              <img src="https://cdn.rawproductionsgmbh.de/2n/home/sitelogo.png" alt="2N Logo" className="h-12 w-auto mb-6 brightness-0 invert opacity-90" data-id="element-255" />
              <p className="text-[#748282] max-w-sm mb-6 font-medium leading-relaxed" data-id="element-256">
                Ihre Akademie für zahnärztliche Fortbildung in Bayern, Nürnberg.
                Praxisnahe, zertifizierte Weiterbildung für Zahnärzte und
                Praxisteams.
              </p>
            </div>

            <div data-id="element-257">
              <h4 className="text-white font-extrabold mb-6 uppercase tracking-wider text-sm" data-id="element-258">
                Navigation
              </h4>
              <ul className="space-y-3 font-medium" data-id="element-259">
                <li data-id="element-260">
                  <Link to="/" className="hover:text-[#59d0d4] transition-colors" data-id="element-261">
                    Startseite
                  </Link>
                </li>
                <li data-id="element-262">
                  <Link to="/termine" className="hover:text-[#59d0d4] transition-colors" data-id="element-263">
                    Termine
                  </Link>
                </li>
                <li data-id="element-264">
                  <Link to="/mediathek" className="hover:text-[#59d0d4] transition-colors" data-id="element-265">
                    Mediathek
                  </Link>
                </li>
                <li data-id="element-266">
                  <Link to="/kontakt" className="hover:text-[#59d0d4] transition-colors" data-id="element-267">
                    Kontakt
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-268">
              <h4 className="text-white font-extrabold mb-6 uppercase tracking-wider text-sm" data-id="element-269">
                Kontakt
              </h4>
              <ul className="space-y-3 text-[#748282] font-medium" data-id="element-270">
                <li data-id="element-271">2N Kurse GbR</li>
                <li data-id="element-272">Ludwigsplatz 1a</li>
                <li data-id="element-273">90403 Nürnberg</li>
                <li className="pt-2" data-id="element-274">
                  Tel:{' '}
                  <a href="tel:091156836360" className="hover:text-[#59d0d4] transition-colors text-white" data-id="element-275">
                    0911 – 56836360
                  </a>
                </li>
                <li data-id="element-276">
                  <a href="mailto:info@2n-fortbildung.de" className="hover:text-[#59d0d4] transition-colors text-white" data-id="element-277">
                    info@2n-fortbildung.de
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-[#748282] font-medium" data-id="element-278">
            <p data-id="element-279">
              &copy; {new Date().getFullYear()} 2N | Zahnärztliche
              Fortbildungen. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-280">
              <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-281">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-282">
                Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}